<template>
  <div style="height: 100%">
    <div class="row response_table">
      <div v-if="error" style="height: 100%">
        <h1 style="text-align: center" >
          {{translate('no_data')}}
        </h1>
      </div>
      <table v-else>
        <thead style="flex: 0">
          <tr>
            <th scope="col">
              {{ translate('simcard_devices.tariff_tab.name') }}
            </th>
            <th scope="col">
              {{ translate('simcard_devices.tariff_tab.ts_add') }}
            </th>
            <th scope="col">
              {{ translate('simcard_devices.tariff_tab.ts_update') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tariff,key) in tariffs" :key="key">
            <td data-label="name">
              {{ tariff.mno_tariff_name }}
            </td>
            <td data-label="ts_add">
              {{ get_date(tariff.ts_add) }}
            </td>
            <td data-label="ts_update">
              {{ tariff.active ? translate('simcard_profile.tariff_active') : get_date(tariff.ts_update) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tariff',
  props: {
    sim_id: {
      type: String
    }
  },

  data () {
    return {
      tariffs: [],
      error: false
    }
  },
  
  mounted () {
    if (this.$route.name === 'simcard_profile_section') {
      this.$http.simcard.getSimcardTariff(this.sim_id, (response) => {
        this.tariffs = response.data
      })
    }
  }
}
</script>
